import { Button } from '@basic';
import { LoaderIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const GoalSubscriptionProcessingButton = ({
  disabled = false,
  fullWidth = true
}: {
  disabled?: boolean;
  fullWidth?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Button
      type='tertiary'
      size='medium'
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={() => {}}
      extraClassName={classNames(setupForDark('bg-label-quaternary'))}
    >
      <div className='flex items-center gap-2'>
        <LoaderIcon size={20} />
        <span>{t('domains.goalSubscriptions.pending.inProgress')}</span>
      </div>
    </Button>
  );
};

export default GoalSubscriptionProcessingButton;
